import { ApiResponse } from "@/utils/ApiResponse";
import apiClient from "@/clients/apiClient";
import { ProductoCreateInterface } from "../../interfaces/productoInterfaces/ProductoCreateInterface";
import { ProductoInterface } from "../../interfaces/productoInterfaces/Producto.interface";

export async function ProductoCreateAction(
formData: FormData
): Promise<ApiResponse<ProductoInterface>> {
  const { data } = await apiClient.post<ProductoInterface>(
    "/gpProductos",
   formData
  );
  return {
    status: 200,
    data,
    message: "Producto creada correctamente",
  };
}
